import React from 'react';
import { Button, Col, Form, FormGroup } from 'reactstrap';
import { reduxForm } from 'redux-form';
import MaterialIcon from 'material-icons-react';

// components
import { css } from '../../components/form/field/typeahead';
import { LocationTypeAheadField } from '../../components/form/field/location-typeahead';

const customStyles = {
  placeholder: (base, state) => ({
    ...css.placeholder(base, state),
    textAlign: 'center'
  })
};

const HomeSearchForm = props => {
  var submitTimeout;

  return (
    <Form onSubmit={props.handleSubmit}>
      <FormGroup row>
        <Col md={{ size: 6, offset: 3 }}>
          <LocationTypeAheadField
            styles={customStyles}
            onChange={(e, newValue, oldValue) => {
              clearTimeout(submitTimeout);
              submitTimeout = setTimeout(() => props.submit(), 0);
            }}
          />
        </Col>
      </FormGroup>
      <Button type="submit" color="primary">
        <MaterialIcon icon="search" />
        SEARCH
      </Button>
    </Form>
  );
};

export default reduxForm({
  form: 'home-search-form'
})(HomeSearchForm);



// WEBPACK FOOTER //
// ./src/containers/Home/HomeSearchForm.js